let root;
let headGlb = "";
let shankGlb = "";
let headPmat = "";
let shankPmat = "";
let diamondModel = "";
let cHeadGlb = "";
let cShankGlb = "";
let headObj;
let shankObj;

function getVDBCookie(cname) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(name) === 0) {
            return c.substring(name.length);
        }
    }
    return "";
}

async function setMetalMaterial(obj, pmat_dmat_file) {
    if (!obj) return;
    const metalMaterial = await viewer.getManager().importer.importSinglePath(pmat_dmat_file);

    obj.modelObject.traverse((o) => {
        if (!o || !o.material) return;
        if (!o.name.startsWith("stone-") && !o.name.startsWith("diamond-")) o.setMaterial(metalMaterial);
    });
    viewer.scene.setDirty();
}
async function setDiamondMaterial(dmat_file) {
    const diamondMaterial = await viewer.getManager().importer.importSinglePath(dmat_file);

    [headObj,shankObj].map(obj => {
        if(!obj) return;
        obj.modelObject.traverse((o) => {
            if (!o || !o.material) return;

            if (o.name.startsWith("diamond-")) {
                viewer.getPluginByType("Diamond").prepareDiamondMesh(o, { cacheKey: o.material.name, normalMapRes: 512 });
                o.setMaterial(diamondMaterial);
            }
            if (o.name.startsWith("stone-")) {
                viewer.getPluginByType("Diamond").prepareDiamondMesh(o, { cacheKey: o.material.name, normalMapRes: 512 });
                o.setMaterial(diamondMaterial);
            }
        });
    });
    viewer.scene.setDirty();
}

async function afterInitViewer(viewer) {
    const loadAndParseCookieData = (cookieName) => {
        const cookieData = getVDBCookie(cookieName);
        return cookieData ? JSON.parse(cookieData) : [];
    };
    const webgiThreeDAssetArray = loadAndParseCookieData("webgi_three_d_asset");
    
    root = await viewer.createObject3D();    
    
    updateModels(webgiThreeDAssetArray);

    await viewer.getManager().addFromPath(webgiThreeDAssetArray?.vjson);

    viewer.scene.activeCamera.position.set(50, 50, 50);
    viewer.scene.activeCamera.positionUpdated();
    viewer.scene.activeCamera.target.set(0, 15, 0);
    viewer.scene.activeCamera.targetUpdated();

   /*  viewer.scene.activeCamera.position.set(7, 7, 7);
    viewer.scene.activeCamera.positionUpdated();
    viewer.scene.activeCamera.target.set(0, 3.5, 0);
    viewer.scene.activeCamera.targetUpdated(); */
}
async function updateModels(webgiThreeDAssetArray) {
    let viewer = window.viewer;
    if (!viewer) return;
    let manager = viewer.getManager();

    headGlb = webgiThreeDAssetArray?.Head?.glb;
    shankGlb = webgiThreeDAssetArray?.Shank?.glb;
    headPmat = webgiThreeDAssetArray?.Head?.pmat;
    shankPmat = webgiThreeDAssetArray?.Shank?.pmat;
    diamondModel = webgiThreeDAssetArray?.dmat;

    if (headGlb) {
        if(headGlb != cHeadGlb){
            cHeadGlb = headGlb;

            const h_obj = ( await manager.addFromPath(headGlb, { pseudoCenter: false, autoScale: false }) )[0];
            root.modelObject.add((headGlb).modelObject);

            if(headObj){
                headObj.dispose();
                headObj = undefined;
            }
            headObj = h_obj;
        }

        if(headObj && headPmat){
            setMetalMaterial(headObj, headPmat);
        }
    }

    if (shankGlb) {
        if(shankGlb != cShankGlb){
            cShankGlb = shankGlb;

            const s_obj = ( await manager.addFromPath(shankGlb, { pseudoCenter: false, autoScale: false }) )[0];
            root.modelObject.add((shankGlb).modelObject);

            if(shankObj){
                shankObj.dispose();
                shankObj = undefined;
            }
            shankObj = s_obj;
        }

        if(shankObj && shankPmat){
            setMetalMaterial(shankObj, shankPmat);
        }
    }
    
    setDiamondMaterial(diamondModel);

    viewer.scene.setDirty();
}

async function handleResize (){
    let viewer = window.viewer;
    if (!viewer) return;

    // Resize canvas to match parent size
    /*const canvas = viewer.renderer.canvas;
    const parent = canvas.parentElement;
    canvas.width = parent.clientWidth;
    canvas.height = parent.clientHeight;*/

    viewer.resize(); // Tell viewer to update sizes
    viewer.scene.setDirty();
    viewer.setDirty(); // Optional: force rerender
};

let resizeTimeout;
window.addEventListener("resize", () => {
    //handleResize();
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        handleResize();
    }, 150);
});

async function setupCoreWebGlThreeDViewer(canvasId) {
    const canvas = document.getElementById(canvasId);

    const viewer = await setupCoreWebGlViewer(
        { canvas },
        { depthTonemap: true }
    );

    window.viewer = viewer;
    viewer.renderEnabled = false;
    await afterInitViewer(viewer);
    viewer.renderer.displayCanvasScaling = Math.min(1.5, window.devicePixelRatio);
    viewer.renderEnabled = true;
}

function resetVariables() {
    headGlb = "";
    shankGlb = "";
    headPmat = "";
    shankPmat = "";
    diamondModel = "";
    cHeadGlb = "";
    cShankGlb = "";
    headObj = undefined;
    shankObj = undefined;
}

async function injectThreeDScript(){
    const scriptUrl = '/apps/plum-app/frontend/webgl-vdb/webgl-3d-viewer.js';

    if (!$('script[src="' + scriptUrl + '"]').length) {
        const scriptElement = $('<script>', {
            src: scriptUrl,
            type: 'text/javascript'
        });
        $('head').append(scriptElement);
    }
}

$(document).ready(function () {
    if ($('#3d_trigger_button').length > 0) {
        $('body').on('click', '#3d_trigger_button', async function () {
            await injectThreeDScript();
            
            if ($('#carousel_image_index').val() == '3d_view') {
                return false;
            }
            
            resetVariables();

            var canvasHtml = '<canvas id="webgl_vdb_canvas" data-engine="three.js r141" style="touch-action: none; width:100%; height:100%; "></canvas>';

            if($('#webgi_three_d_player_div').length > 0){
                $("#threekit_player_div .swiper-wrapper").hide();
                $('#webgi_three_d_player_div').show();
                $('#webgi_three_d_player_div').html(canvasHtml);
                $('#webgi_three_d_player_div').addClass('canvas-mode');
                $('#webgi_three_d_player_div').addClass('tab-active');
            }else{
                $('#threekit_player_div').html(canvasHtml);
                $('#threekit_player_div').addClass('canvas-mode');
            }

            $('#carousel_image_index').val('3d_view');

            await setupCoreWebGlThreeDViewer("webgl_vdb_canvas");
        });
    }
});

async function loadThreeDOnPageLoad(){
    await injectThreeDScript();
            
    /* if ($('#carousel_image_index').val() == '3d_view') {
        return false;
    } */
    
    resetVariables();

    var canvasHtml = '<canvas id="webgl_vdb_canvas" data-engine="three.js r141" style="touch-action: none; width:100%; height:100%; "></canvas>';

    if($('#webgi_three_d_player_div').length > 0){
        $('#webgi_three_d_player_div').show();
        $('#webgi_three_d_player_div').html(canvasHtml);
        $('#webgi_three_d_player_div').addClass('canvas-mode');
    }

    await setupCoreWebGlThreeDViewer("webgl_vdb_canvas");
}